import qs from 'qs';
import Cookies from 'js-cookie';

export default {
  /**
   * 初始化
   */
  init: () => {
    const p = qs.parse(window.location.search.replace('?', ''));
    // localStorage.removeItem('buyerCookie');
    if (p.tokenshared) {
      p.tokenshared
        .split(';')
        .map(t => t.trim())
        .forEach(str => {
          const [k, v] = str.split('=');
          Cookies.set(k, v);
          // if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
          //   // 移动端可能cookie设置失败
          //   // localStorage.setItem(k, v);
          // }
        });
      // restart href 2
      location.href = `${p.href}`;
    }
  },
  /**
   * 获取免登URL
   * @param {*} href ex.'http://baidu.com/index?q=1
   */
  getUrl: ({ href }) => {
    // document.cookie被公共方法包装过,得先取原值
    // 也就是说get和set必须成对出现
    const SPTAG = '; ';
    const originCookieStr = document.cookie
      .split(SPTAG)
      .map(str => {
        const [k] = str.split('=');
        const newV = Cookies.get(k);
        return `${k}=${newV}`;
      })
      .join(SPTAG);
    return `${location.origin}${qs.stringify(
      {
        // todo hostonly
        tokenshared: originCookieStr,
        href: href,
      },
      {
        addQueryPrefix: true,
      }
    )}`;
  },
};
